import { httpCreate } from './http';
const http = httpCreate('/srv/download');
export const download = {
	download(url) {
		return http.get('', {
			url: '',
			baseURL: url,
			responseType: 'arraybuffer'
		});
	}
};
